import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_9a5ghk4bfm: FaireCollectionEntity = {
  token: "pbc_9a5ghk4bfm",
  type: "collection",
  name: "art prints",
  heroImageUrl:
    "https://cdn.faire.com/fastly/64224af6ca86142c66a7672be30913dff5c7cb4bd733f0215a175eb9246211fd.jpeg",
  itemCount: 92,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:24.144Z",
    importedBy: "entity-db-import-collections",
  },
};
